/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React from 'react';
import Props, {DispatchProps, StateProps} from './Props';

import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {
	confirmEmployeeRegistrationSceneActivated,
	confirmEmployeeRegistrationSceneBackButtonClicked,
	confirmEmployeeRegistrationSceneDeactivated,
	confirmEmployeeRegistrationScenePasswordInputChanged,
	confirmEmployeeRegistrationScenePasswordSubmitted,
	confirmEmployeeRegistrationScenePhoneVerificationCodeInputChanged,
	confirmEmployeeRegistrationScenePhoneVerificationCodeSubmitted,
	confirmEmployeeRegistrationSceneRequestRestartPhoneVerification,
	confirmEmployeeRegistrationSceneRequestRetryPhoneVerification
} from './actions';
import {DisplayType} from './displayType';
import CenteredFormPanel from '../../components/CenteredFormPanel';
import RetryPhoneVerificationStart from '../../components/RetryPhoneVerificationStart';
import PhoneVerificationCode from '../../components/PhoneVerificationCode';
import EnterPassword from '../../components/EnterPassword';
import AlertWithLoginLink from '../../components/AlertWithLoginLink';
import {RootState} from '../../reducers';

class ConfirmEmployeeRegistration extends React.Component<Props> {

	componentDidMount() {
		const props: Readonly<Props> = this.props;

		props.onActivate();
	}

	componentWillUnmount() {
		const props: Readonly<Props> = this.props;

		props.onDeactivate();
	}

	render() {
		const props: Readonly<Props> = this.props;

		let display: JSX.Element | null;

		const retryPhoneVerificationStartState = props.retryPhoneVerificationStart;
		const retryPhoneVerificationStartDispatch = props.retryPhoneVerificationStartDispatch;
		const phoneVerificationCodeState = props.phoneVerificationCode;
		const phoneVerificationCodeDispatch = props.phoneVerificationCodeDispatch;
		const enterPasswordState = props.enterPassword;
		const enterPasswordDispatch = props.enterPasswordDispatch;
		switch (props.index.displayType) {
			case DisplayType.DISPLAY_TYPE_RETRY_PHONE_VERIFICATION_START:
				display = <RetryPhoneVerificationStart
					buttonText={retryPhoneVerificationStartState.buttonText}
					submitDisabled={retryPhoneVerificationStartState.submitDisabled}
					onRetryPhoneVerificationStart={retryPhoneVerificationStartDispatch.onRetryPhoneVerificationStart}/>;
				break;
			case DisplayType.DISPLAY_TYPE_PHONE_VERIFICATION_CODE:
				display = <PhoneVerificationCode
					maximumDurationInSeconds={phoneVerificationCodeState.maximumDurationInSeconds}
					verificationStopped={phoneVerificationCodeState.verificationStopped}
					violations={phoneVerificationCodeState.violations.verificationCode}
					submitDisabled={phoneVerificationCodeState.submitDisabled}
					onVerificationCodeChange={phoneVerificationCodeDispatch.onVerificationCodeChange}
					onSubmitVerificationCode={phoneVerificationCodeDispatch.onSubmitVerificationCode}
					onSubmitVerificationRestart={phoneVerificationCodeDispatch.onSubmitVerificationRestart}
					onRetryPhoneVerificationStart={phoneVerificationCodeDispatch.onRetryPhoneVerificationStart}/>;
				break;
			case DisplayType.DISPLAY_TYPE_ENTER_PASSWORD:
				display = <EnterPassword
					strength={enterPasswordState.strength}
					minimumStrength={enterPasswordState.minimumStrength}
					submitDisabled={enterPasswordState.submitDisabled}
					email={enterPasswordState.email}
					violations={enterPasswordState.violations.password}
					onPasswordChange={enterPasswordDispatch.onPasswordChange}
					onSubmitPassword={enterPasswordDispatch.onSubmitPassword}/>;
				break;
			case DisplayType.DISPLAY_TYPE_COMPLETION_MESSAGE:
				display = <AlertWithLoginLink
					reasonMessage={'Uw account is gereed.'}
					onLoginClick={props.alertWithLoginLinkDispatch.onLoginClick}/>;
				break;
			case DisplayType.DISPLAY_TYPE_NONE:
			default:
				display = null;
		}

		return (
			<CenteredFormPanel title="Registratie bevestigen" message={props.index.message} messageType={props.index.messageType}>
				{display}
			</CenteredFormPanel>
		);
	}
}

const mapStateToProps = (state: RootState): StateProps => ({
	enterPassword: state.confirmEmployeeRegistration.enterPassword,
	index: state.confirmEmployeeRegistration.index,
	phoneVerificationCode: state.confirmEmployeeRegistration.phoneVerificationCode,
	retryPhoneVerificationStart: state.confirmEmployeeRegistration.retryPhoneVerificationStart
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	alertWithLoginLinkDispatch: {
		onLoginClick: () => dispatch(confirmEmployeeRegistrationSceneBackButtonClicked())
	},
	enterPasswordDispatch: {
		onPasswordChange: (password) => dispatch(confirmEmployeeRegistrationScenePasswordInputChanged({evaluationRequest: {password}})),
		onSubmitPassword: (password) => dispatch(confirmEmployeeRegistrationScenePasswordSubmitted({command: {password}}))
	},
	onActivate: () => dispatch(confirmEmployeeRegistrationSceneActivated()),
	onDeactivate: () => dispatch(confirmEmployeeRegistrationSceneDeactivated()),
	phoneVerificationCodeDispatch: {
		onRetryPhoneVerificationStart: () => dispatch(confirmEmployeeRegistrationSceneRequestRetryPhoneVerification()),
		onSubmitVerificationCode: (verificationCode) =>
			dispatch(confirmEmployeeRegistrationScenePhoneVerificationCodeSubmitted({command: {verificationCode}})),
		onSubmitVerificationRestart: () => dispatch(confirmEmployeeRegistrationSceneRequestRestartPhoneVerification()),
		onVerificationCodeChange: () => dispatch(confirmEmployeeRegistrationScenePhoneVerificationCodeInputChanged())
	},
	retryPhoneVerificationStartDispatch: {
		onRetryPhoneVerificationStart: () => dispatch(confirmEmployeeRegistrationSceneRequestRetryPhoneVerification())
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmployeeRegistration);
